<template>
  <div
    data-aos="fade"
    data-aos-delay="450"
    data-aos-offset="150"
    :class="`dbc-gl-section dbc-c-divider__position-${content.position}`"
  >
    <DbcSvg
      name="dbc-divider"
      class="max-mobile:[&>svg]:w-[80%] max-tablet:[&>svg]:w-[50%]"
    />
  </div>
</template>

<script setup lang="ts">
defineProps<{
  content: ContentDivider
}>()
</script>
